import {setBillingData} from '@/redux-store/slices/billing-data';
import {store} from '@/redux-store/store';
import keycloakAxios from '@/services/axios';
import {sanitizeBillingData} from '@/services/billing-data';

export const getBillingData = async () => {
  const response = await keycloakAxios.get('payments/billing-data');

  if (response.status >= 300) {
    throw new Error(
      `Error getting billing data Invalid status code: ${response.status}`
    );
  }

  const sanitizedBillingData = sanitizeBillingData(response.data);

  store.dispatch(setBillingData(sanitizedBillingData));

  return sanitizedBillingData;
};
